import { MetaQualityRating } from 'modules/graphql/types/GraphQLTemplate';

export enum SERVICE_PROVIDERS {
  /**
   * These names map directly to the EgressServiceProvider object in the backend.
   * If they are ever updated there, they would need to be updated here as well.
   */
  ITERABLE = 'SES',
  MAILGUN = 'MailGun',
  MAILGUN_EU = 'MailGunEU',
  DYN = 'Dyn',
  SENDGRID = 'SendGrid',
  SPARKPOST = 'SparkPost',
  SPARKPOST_EU = 'SparkPostEU',
  SPARKPOST_ELITE = 'SparkPostElite',
  TELNYX = 'Telnyx',
  TWILIO = 'Twilio',
  CUSTOM_MTA = 'CustomMTA',
  INFOBIP = 'InfoBip', // WhatsApp
  /** Unused Providers */
  SFMC = 'SFMC', // SFMC is deprecated
  COINBASE_MTA = 'CoinbaseMTA', // CoinbaseMTA is not in use
  NO_OP = 'NoOp', // NoOp is a coding artifact
  SES_THIRD_PARTY = 'SESThirdParty',
}

export type DEFAULT_PROVIDER = SERVICE_PROVIDERS.ITERABLE;

export type EMAIL_PROVIDERS =
  | SERVICE_PROVIDERS.ITERABLE
  | SERVICE_PROVIDERS.MAILGUN
  | SERVICE_PROVIDERS.MAILGUN_EU
  | SERVICE_PROVIDERS.DYN
  | SERVICE_PROVIDERS.SENDGRID
  | SERVICE_PROVIDERS.SPARKPOST
  | SERVICE_PROVIDERS.SPARKPOST_ELITE
  | SERVICE_PROVIDERS.SPARKPOST_EU
  | SERVICE_PROVIDERS.CUSTOM_MTA;

export type SMS_PROVIDERS = SERVICE_PROVIDERS.TELNYX | SERVICE_PROVIDERS.TWILIO;

export type OAuth2AuthParams = { clientId: string; clientSecret: string; tokenEndpoint: string };

export type CustomHeaders = { [key: string]: string };

export type CustomMTAConfig = {
  apiEndpoint: string;
  authParams: OAuth2AuthParams;
  authType: string;
  customHeaders: CustomHeaders;
  id: number;
  name: string;
};

export type EspAccountFields = {
  id: number;
  name: string;
  truncatedApiKey: string;
  binding: string | null;
  customApiEndpoint: string | null;
  isDefault: boolean;
  isSenderIterable?: boolean;
  signingSecretPrefix?: string;
  projectId: number;
};

export type EspAccount = EspAccountFields & {
  esp: SERVICE_PROVIDERS;
};

export type EspAccountWithCustomMTAConfig = EspAccount & {
  customMTAConfig: CustomMTAConfig;
};

export type EmailEspAccount = EspAccount & {
  esp: EMAIL_PROVIDERS;
};

export type SmsEspAccount = EspAccount & {
  esp: SMS_PROVIDERS;
};

export type WhatsAppQualityRatingDefinition = `${MetaQualityRating}`;

export enum WhatsAppSenderStatus {
  Banned = 'Banned',
  Connected = 'Connected',
  Deleted = 'Deleted',
  Disconnected = 'Disconnected',
  Flagged = 'Flagged',
  Migrated = 'Migrated',
  Pending = 'Pending',
  RateLimited = 'RateLimited',
  Restricted = 'Restricted',
  Unknown = 'Unknown',
  Unverified = 'Unverified',
}

export type StatusDefinition = `${WhatsAppSenderStatus}`;

export enum WhatsAppSendLimit {
  Limit100K = 'Limit100K',
  Limit10K = 'Limit10K',
  Limit1K = 'Limit1K',
  Limit250 = 'Limit250',
  Limit50 = 'Limit50',
  LimitNa = 'LimitNa',
  Unlimited = 'Unlimited',
}

export type SendLimitDefinition = `${WhatsAppSendLimit}`;

export type WhatsAppSenderFields = {
  id: number;
  senderId?: string;
  phoneNumber?: string;
  qualityRating?: WhatsAppQualityRatingDefinition;
  status?: WhatsAppSenderStatus;
  sendLimit?: SendLimitDefinition;
  about: string;
  address: string;
  description: string;
  email: string;
  vertical: string;
  websites?: string[];
  displayName: string;
};

export type WhatsAppEspAccount = EspAccount & {
  senders: WhatsAppSenderFields[];
};
